import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { Input } from 'antd';
import styles from './CandidateJobsHeader.module.scss';
import CandidateJobsFilter from '../CandidateJobsFilter/CandidateJobsFilter';
import placeholder from '../Placeholders/PlaceholdersMessages';

function CandidateJobsHeader(props) {
  const {
    jobs,
    candidateId,
    fetchCandidateJobs,
    onSearchChange,
    onSearch,
    searchTerm,
    jobAggregations,
    selectedCandidateStageFilterOptions,
    setSelectedCandidateStageFilterOptions,
    selectedJobStatusFilterOptions,
    setSelectedJobStatusFilterOptions,
    isCandidateViewHeaderVisible,
    setFilterPopoverVisbility,
    isFilterPopoverVisible,
    isATSViewActive,
    intl,
  } = props;
  return (
    <div>
      <div
        className={classNames(styles.jobsTabHeader, {
          [styles.jobsHeaderForAtsView]: isATSViewActive,
        })}
      >
        <div className={styles.searchAndFilter}>
          <Input.Search
            size="default"
            placeholder={intl.formatMessage({ ...placeholder.searchLabel })}
            allowClear
            className={styles.jobsInputSearch}
            onChange={onSearchChange}
            onSearch={onSearch}
            value={searchTerm}
          />
          <CandidateJobsFilter
            jobs={jobs}
            jobAggregations={jobAggregations}
            fetchCandidateJobs={fetchCandidateJobs}
            candidateId={candidateId}
            selectedCandidateStageFilterOptions={selectedCandidateStageFilterOptions}
            setSelectedCandidateStageFilterOptions={setSelectedCandidateStageFilterOptions}
            selectedJobStatusFilterOptions={selectedJobStatusFilterOptions}
            setSelectedJobStatusFilterOptions={setSelectedJobStatusFilterOptions}
            searchTerm={searchTerm}
            isCandidateViewHeaderVisible={isCandidateViewHeaderVisible}
            isFilterPopoverVisible={isFilterPopoverVisible}
            setFilterPopoverVisbility={setFilterPopoverVisbility}
          />
        </div>
      </div>
    </div>
  );
}

export default injectIntl(CandidateJobsHeader);
export { CandidateJobsHeader as CandidateJobsHeaderWithoutInjectIntl };
